<section class="rcx-table">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body table-responsive">
            <div class="row d-flex justify-content-between align-items-center">
              <div class="col-lg-auto">
                <h5 class="card-title m-0">
                  <i class="ri-group-3-line  me-1 text-primary"></i>Teams
                </h5>
              </div>
              <div class="col-sm-12 col-md-5 col-lg-3 me-auto">
                <div class="input-group">
                  <span class="input-group-text bg-primary" id="search" ngbTooltip="Search teams by name."
                    placement="top" container="body">
                    <i class="bx bx-search-alt"></i>
                  </span>
                  <input type="text" class="form-control border-start-0" id="search" placeholder="Search..."
                    autocomplete="off" [(ngModel)]="searchKeyword">
                </div>
              </div>
              <div class="col-sm-12 col-md-auto">
                <button type="button" class="btn btn-secondary" (click)="upsertTeam()" id="add-btn"
                  [ngClass]="{'not-allowed':!privilege.canEdit}"
                  [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): project-pilot.team.edit' : ''">
                  <i class="bx bx-plus"></i> Add Team
                </button>
              </div>
            </div>
            <table class="table" id="table">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="70">#</th>
                  <th scope="col" width="300">Name</th>
                  <th scope="col" width="300">Code</th>
                  <th scope="col" width="500">Description</th>
                  <th scope="col" width="300">Members</th>
                  <th scope="col" width="160" class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let team of tableData.content | search : 'name' : searchKeyword; let i=index">
                  <td>{{i+1}}.</td>
                  <td>{{team.name}}</td>
                  <td>{{team.code}}</td>
                  <td class="team-desc">{{team.description}}</td>
                  <td>
                    <div *ngIf="team?.teamMemberDtos?.length; else noMembers"
                      class="d-flex flex-wrap align-items-center gap-1">
                      <ng-container *ngFor="let member of team.teamMemberDtos">
                        <img class="avatar-sm rounded-circle border border-light-subtle shadow-sm"
                          [ngbTooltip]="member.employeeName + ' (' + member.teamRoleName + ')'"
                          [src]="member.employeeAvatar && member.employeeAvatar.trim() !== '' ? member.employeeAvatar : 'assets/images/avatar.png'"
                          alt="avatar"
                          style="object-fit: cover; object-position: top; background-color: #fff; transform: scale(1.7) translateY(5%);">
                      </ng-container>
                    </div>
                    <ng-template #noMembers>
                      <span class="text-danger fw-bold"></span>
                    </ng-template>
                  </td>

                  <td class="actions">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" [id]="i" [checked]="team.disabled" [ngClass]="{
                          'no-event': team?.isDeleteInProgress,
                          'not-allowed': !privilege.canEdit
                        }" [ngbTooltip]="!privilege.canEdit? 'You need permissions for this action. Required permission(s): project-pilot.team.edit'
                            : !team.disabled ? 'Mark ' + team.name + ' as enabled.': 'Mark ' + team.name + ' as disabled.'
                        " placement="top" container="body" (change)="toggleTeamStatus(team)" />
                      <label class="form-check-label" [for]="i"></label>
                    </div>
                    <i class="bx bx-edit alert-primary" id="edit-btn"
                      [ngClass]="{'no-event':team?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                      [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): project-pilot.team.edit' : 'Update Team'"
                      (click)="upsertTeam(team)"></i>
                    <i *ngIf="!team?.isDeleteInProgress" class="bx bx-trash alert-secondary" id="update-btn"
                      [ngClass]="{'not-allowed':!privilege.canDelete}"
                      [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): project-pilot.team.delete' : 'Delete Team'"
                      (click)="deleteTeam(team,i)"></i>
                    <div *ngIf="team?.isDeleteInProgress" role="status"
                      class="spinner-border spinner-border-sm text-danger">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
                <tr class="no-data">
                  <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="6">Fetching data, please wait...</td>
                  </ng-container>
                  <ng-template #noDataTemplate>
                    <ng-container *ngIf="tableData.content && tableData.content.length < 1; else noSearchResults">
                      <td colspan="6">No teams were found.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                      <td colspan="6"
                        *ngIf="searchKeyword && (tableData.content | search : 'name' : searchKeyword).length == 0">
                        No teams were found for the search results.
                      </td>
                    </ng-template>
                  </ng-template>
                </tr>
              </tbody>
            </table>
            <div class="row justify-content-between align-items-center pt-3">
              <div class="col-lg-auto">
                <div class="pagination-entries" id="tickets-table_length">
                  <label class="d-flex align-items-center m-0">
                    <span>Items per page</span>
                    <select name="tickets-table_length" aria-controls="tickets-table" [(ngModel)]="tableData.size"
                      (change)="loadTableData(null)"
                      class="custom-select custom-select-sm form-control form-control-sm mx-2">
                      <option *ngFor="let page of pageSizes" [value]="page">{{page}}</option>
                    </select>
                  </label>
                </div>
              </div>
              <div *ngIf="tableData?.content?.length > 0" class="col-lg-auto">
                <ngb-pagination [collectionSize]="tableData.totalElements" [(page)]="tableData.number"
                  [pageSize]="tableData.size" (pageChange)="onPageChange($event)">
                </ngb-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>